function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "svgg"
}, /*#__PURE__*/React.createElement("path", {
  id: "path0",
  d: "M92.000 107.000 L 92.000 122.000 76.000 122.000 L 60.000 122.000 60.000 185.000 L 60.000 248.000 76.000 248.000 L 92.000 248.000 92.000 263.000 L 92.000 278.000 184.000 278.000 L 276.000 278.000 276.000 293.000 L 276.000 308.000 291.000 308.000 L 306.000 308.000 306.000 324.000 L 306.000 340.000 323.000 340.000 L 340.000 340.000 340.000 231.000 L 340.000 122.000 324.000 122.000 L 308.000 122.000 308.000 107.000 L 308.000 92.000 200.000 92.000 L 92.000 92.000 92.000 107.000 M306.000 200.000 L 306.000 276.000 292.000 276.000 L 278.000 276.000 278.000 261.000 L 278.000 246.000 186.000 246.000 L 94.000 246.000 94.000 185.000 L 94.000 124.000 200.000 124.000 L 306.000 124.000 306.000 200.000 ",
  fill: "currentColor",
  fillRule: "evenodd"
}));

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 400,
    viewBox: "0, 0, 400,400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.3a144e6a.svg";
export { ForwardRef as ReactComponent };